import { render, staticRenderFns } from "./course-list-item.vue?vue&type=template&id=2af8db90&scoped=true"
import script from "./course-list-item.vue?vue&type=script&lang=js"
export * from "./course-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af8db90",
  null
  
)

export default component.exports